import { createSlice } from '@reduxjs/toolkit';
import { handleGetCommonSearch } from './commonSearchThunk';
import { ICommonSearchItem } from '~/utils/interface/commonField';

export interface CommonSearchState {
  options: Array<ICommonSearchItem>;
}

const initialState: CommonSearchState = {
  options: [],
};

const commonSearchSlice = createSlice({
  name: 'commonSearch',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder.addCase(handleGetCommonSearch.fulfilled, (state, action) => {
      state.options = action.payload;
    });
  },
});

export const commonSearchActions = commonSearchSlice.actions;

const commonSearchReducer = commonSearchSlice.reducer;
export default commonSearchReducer;
